export const payLoad = {
	'request':
		'{\n' +
		'  "events": [\n' +
		'    {\n' +
		'      "serviceCategoryCode": {\n' +
		'        "codeValue": "core"\n' +
		'        },\n' +
		'      "eventNameCode": {\n' +
		'        "codeValue": "consumer-application-subscription-credential.read"\n' +
		'        },\n' +
		'      "data": {\n' +
		'      "transform": {\n' +
		'          "queryParameter": "$filter=subscriberOrganizationOID eq \'<subscribed client’s Organization OID (OOID)>\'"\n' +
		'        }\n' +
		'      }\n' +
		'    }\n' +
		'  ]\n' +
		'}\n',
	'response':
		'{\n' +
		'  "events": [\n' +
		'    {\n' +
		'      "eventID": "c07febd1-f940-4ccf-90c3-e3e0bb7fd29e",\n' +
		'      "effectiveDateTime": "2016-01-20T16:47:26.591Z",\n' +
		'      "creationDateTime": "2016-01-20T16:47:26.591Z",\n' +
		'      "recordDateTime": "2016-01-20T16:47:26.591Z",\n' +
		'      "data": {\n' +
		'        "output": {\n' +
		'          "consumerApplicationSubscriptionCredentials": [\n' +
		'            {\n' +
		'              "clientSecret": "7643ea2b-c211-418e-a00e-ae11a4095fd5",\n' +
		'              "clientID": "ffdd6086-fe87-4a6d-9af8-0887460b7412",\n' +
		'              "subscriberOrganizationOID": "G3RSJ4C4V1Y5J8FW"\n' +
		'            }\n' +
		'          ]\n' +
		'        }\n' +
		'      },\n' +
		'      "eventStatusCode": {\n' +
		'        "codeValue": "complete",\n' +
		'        "shortName": "Complete"\n' +
		'      }\n' +
		'    }\n' +
		'  ]\n' +
		'}'
}